import React, {Fragment, FunctionComponent} from "react";
import {PremiumService, Service} from "@App/types";
import {Checkbox} from "@App/Components/common/Checkbox";
import {useTranslation} from "react-i18next";

type DriverDataServiceStepProps = {
    requiredServices: Service[],
    requiredPremiumServices: PremiumService[],
    optionalServices: Service[],
    optionalPremiumServices: PremiumService[],
    prohibitedServices: Service[],
    prohibitedPremiumServices: PremiumService[],
    togglePremiumService: any,
    premiumServices: PremiumService[],
    services: Service[],
    toggled: any,
    serviceToggled: any,
    nextStep: any,
    selectService: any,
    service: Service,
};

export const DriverDataServiceStep: FunctionComponent<DriverDataServiceStepProps> = (props: DriverDataServiceStepProps)  => {

    const {t} = useTranslation()

    return (
        <Fragment>
            <div className="overflow-hidden mb-4 mt-4">
                {(props.requiredServices?.length > 0 || props.requiredPremiumServices?.length > 0) && (
                    <Fragment>
                        <h3 className={'mb-3 driverdataSubheadlineMandatory'}>{t('driverDataStep.mandatory')}</h3>
                        <div className={'driverdataSubheadlineMandatoryHover'}>{t('driverDataStep.mandatoryHover')}</div>
                        {props.requiredServices?.map((service) => (
                            <Fragment key={'fragment-' + service.id}>
                                <Checkbox key={service.id} status={props.serviceToggled(service)}
                                          title={service.name}
                                          disabled={true}
                                          onChange={() => {
                                              return
                                          }}
                                />
                            </Fragment>
                        ))}
                        {props.requiredPremiumServices?.map((premiumService) => (
                            <Fragment key={'fragment-' + premiumService.id}>
                                <Checkbox key={premiumService.id}
                                          status={props.toggled(premiumService, props.premiumServices)}
                                          title={premiumService.name + (premiumService.paid ? '*' : '')}
                                          disabled={true}
                                          onChange={() => props.togglePremiumService(premiumService, props.premiumServices)}
                                />
                            </Fragment>
                        ))}
                    </Fragment>
                )}
                {(props.optionalServices?.length > 0 || props.optionalPremiumServices?.length > 0) && (
                    <Fragment>
                        <h3 className={'mb-3 mt-4 driverdataSubheadlineOptional'}>{t('driverDataStep.optional')}</h3>
                        <div className={'driverdataSubheadlineOptionalHover'}>{t('driverDataStep.optionalHover')}</div>
                        {props.optionalServices?.map((service) => (
                            <Fragment key={'fragment-' + service.id}>
                                <Checkbox key={service.id} status={props.serviceToggled(service)}
                                          title={service.name}
                                          onChange={() => props.selectService(service)}
                                />
                            </Fragment>
                        ))}
                        {props.optionalPremiumServices?.map((premiumService) => (
                            <Fragment key={'fragment-' + premiumService.id}>
                                <Checkbox key={premiumService.id}
                                          status={props.toggled(premiumService, props.premiumServices)}
                                          title={premiumService.name + (premiumService.paid ? '*' : '')}
                                          onChange={() => props.togglePremiumService(premiumService, props.premiumServices)}
                                />
                            </Fragment>
                        ))}
                    </Fragment>
                )}
                {(props.prohibitedPremiumServices?.length > 0 || props.prohibitedServices?.length > 0)&& (
                    <Fragment>
                        <h3 className={'mb-3 mt-4 driverdataSubheadlineNotavailable'}>{t('driverDataStep.prohibited')}</h3>
                        <span className={'driverdataSubheadlineNotavailableHover'}>{t('driverDataStep.prohibitedHover')}</span>
                        {props.prohibitedServices?.map((service) => (
                            <Fragment key={'fragment-' + service.id}>
                                <span className={'font-bold'}>{service.name}</span><br/>
                            </Fragment>
                        ))}
                        {props.prohibitedPremiumServices?.map((premiumService) => (
                            <Fragment key={'fragment-' + premiumService.id}>
                                <Fragment key={'fragment-' + premiumService.id}>
                                    <Checkbox key={premiumService.id} status={props.serviceToggled(premiumService)}
                                              title={premiumService.name}
                                              disabled={true}
                                              onChange={() => {
                                                  return
                                              }}
                                    />
                                </Fragment>
                            </Fragment>
                        ))}
                    </Fragment>
                )}

                <div
                    onClick={props.nextStep}
                    className={`${props.premiumServices.length >= 1 || props.service ? '' : 'cursor-pointer pointer-events-none no-underline'}`}>
                    <div
                        className={`${props.premiumServices.length >= 1  || props.service ? 'bg-primary' : 'bg-primary-100'} w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline`}>
                        {t('weiter')}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
